// imports
import React from 'react';
import clsx from 'clsx';
import PaperBG from '../../atoms/background/paper';

// interfaces / types / consts
interface Props {
  className?: string;
  sidebar: JSX.Element;
  children: JSX.Element | JSX.Element[];
}

// exports
export default function TabView(props: Props): JSX.Element {
  const { children, sidebar, className } = props;
  // render
  return (
    <div className={clsx('tab-view-container', className)}>
      <div className="page-container">
        <div className="sidebar">{sidebar}</div>
        <div className="content">
          <PaperBG />
          <div className="outlet">{children}</div>
        </div>
      </div>
    </div>
  );
}

TabView.defaultProps = {
  className: ''
};
